import { gql } from '@apollo/client';

export const GetViewerOrganization = gql`
  query ViewerOrganization($organizationId: ID!) {
    viewerOrganization(organizationId: $organizationId) {
      id
      name
      slug
      role
      isActive
      isFree
      defaultReferralSearchRadius
      defaultDateFilterRange
      defaultReferralSort
      referralSettings {
        enableSearchLinkWhenCanceled
        enableCancelAndRescheduleButton
        hideReferralOrder
        hideSchedulingButtons
        enableRejectReferralWithAppointment
        useDeclineReferralLabel
      }
      isCovid
      hasSso
      hasSsoStrict
      accessCenterProfileId
      showInsuranceFilters
      showSendToPatient
      hideEmailFieldInReferral
      useClickToSearchForPatients
      region {
        id
        name
      }
      locations {
        id
        name
        sends
        receives
      }
      featureFlags {
        id
        name
      }
      linkTypeAdministrationEnabled
      locationRequiredFieldsEnabled
      organizationInsurancesEnabled
      profileRequiredFieldsEnabled
      taxonomyAdministrationEnabled
      freePlanConfiguration {
        id
        name
        appointmentsPerWeek
        locations
        profiles
        providers
        users
      }
      cancelReasons {
        key
        value
      }
      referralCancelReasons {
        key
        value
      }
      referralRejectionReasons {
        key
        value
      }
      consumerSchedulingSettings {
        noAvailabilityText
      }
    }
  }
`;

export const GetSimplifiedViewer = gql`
  query Viewer($skip_locations: Boolean) {
    viewer(skip_locations: $skip_locations) {
      id
      name
      email
      blockitAdmin
      organizations {
        id
        name
        role
        isActive
      }
    }
  }
`;
